export type QueryInclusionType = 'include' | 'exclude';

export enum QueryInclusionEnum {
  Include = 'include',
  Exclude = 'exclude',
}
